import { createTRPCReact } from '@trpc/react-query';
import { httpBatchLink } from '@trpc/client';
import { getDevAuthHeaders } from '../utils/devAuth';
import type { AppRouter } from '@wineryxplorer/api';

export const trpc = createTRPCReact<AppRouter>();

// Use Vite's environment variable handling
const apiUrl = import.meta.env.VITE_API_URL 
  ? `${import.meta.env.VITE_API_URL}/trpc`
  : 'http://localhost:3001/trpc';

export const trpcClient = trpc.createClient({
  links: [
    httpBatchLink({
      url: apiUrl,
      fetch: (url, options) => {
        return fetch(url, {
          ...options,
          credentials: 'include', // Send cookies with cross-origin requests
        });
      },
      headers: () => {
        const headers: Record<string, string> = {
          // Add development authentication headers if enabled
          ...getDevAuthHeaders(),
        };

        // Add session token if available
        const sessionToken = localStorage.getItem('session-token');
        if (sessionToken) {
          headers['authorization'] = `Bearer ${sessionToken}`;
        }

        return headers;
      },
    }),
  ],
});

